<template>
  <div class="content">
    <!-- <div class="header text-center">
      <h3 class="title">Timeline</h3>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <card
          class="card-timeline card-plain"
          bodyClasses="timeline-infinite-scroll-card"
        >
          <ul id="scroll-content" ref="scrollContainer" class="timeline">
            <div v-show="hasNextPage" ref="load" class="loader">
              <strong>{{ $t("geral.loadingMoreData") }}</strong>
            </div>
            <time-line-item
              v-for="item in messages"
              :key="item.messageId"
              :inverted="item.whoInteracted.toUpperCase() == 'SUPORTE'"
              :badge-type="
                item.whoInteracted.toUpperCase() == 'SUPORTE'
                  ? 'success'
                  : 'info'
              "
              :badge-icon="
                item.whoInteracted.toUpperCase() == 'SUPORTE'
                  ? 'tim-icons icon-headphones'
                  : 'tim-icons icon-bank'
              "
              :item-type="
                item.whoInteracted.toUpperCase() == 'SUPORTE'
                  ? 'success'
                  : 'info'
              "
            >
              <!-- <span slot="header" class="badge badge-pill badge-danger">
              {{ item.occurrenceDescription }}
            </span> -->
              <span slot="header">
                <b> {{ item.personDisplayName }}</b>
                <a
                  :href="`https://wa.me/${item.phoneNumber}?text=`"
                  target="_blank"
                >
                  {{ formatarTelefone(item.phoneNumber) }}
                </a>
              </span>
              <div slot="content">
                {{ item.text.trim() }}
              </div>
              <h6 slot="footer">
                {{ getDateFormatted(item.interactionAt) }}
              </h6>
            </time-line-item>
          </ul>
        </card>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  components: {
    TimeLineItem: () => import("@/components/Timeline/TimeLineItem.vue"),
  },
  props: {
    serviceId: Number,
  },
  data: function () {
    return {
      messages: [],
      hasNextPage: true,
      observer: null,
      observerCount: null,
    };
  },
  computed: {},
  created() {},
  destroyed() {
    this.observer.disconnect();
  },
  mounted() {
    this.handleScroll().then((resp) => {
      const sleep = (milliseconds) => {
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
      };
      const scrollContainer = this.$refs.scrollContainer;

      const doSomething = async () => {
        await sleep(200);
        scrollContainer.scrollTo(0, scrollContainer.scrollHeight);
        this.observer = new IntersectionObserver(this.infiniteScroll);
        this.observer.observe(this.$refs.load);
      };

      doSomething();
    });
  },
  methods: {
    async addNewItems() {
      try {
        const ctx = {
          firstPage: this.messages.length == 0,
          hasNextPage: false,
        };

        let menorId = 0;
        if (this.messages.length > 0) {
          menorId = this.messages.reduce(
            (min, mensagem) =>
              mensagem.messageId < min ? mensagem.messageId : min,
            this.messages[0].messageId
          );
        }

        const response = await this.$apiScheduler.get(
          `api/supportchat/messages/paginate/service?serviceId=${this.serviceId}&serviceMessageIdEnds=${menorId}`
        );
        for (let item of response.data) {
          this.messages.unshift(item);
        }

        this.hasNextPage = response.data.length >= 10;
      } catch (err) {
        console.log(err);
        console.log(err.response);
        if (err.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        }
      }
    },
    formatarTelefone(numero) {
      const ddd = numero.slice(0, 2);
      const codigoArea = numero.slice(2, 4);
      const parte1 = numero.slice(4, 9);
      const parte2 = numero.slice(9, 13);

      return `+${ddd} (${codigoArea}) ${parte1}-${parte2}`;
    },
    getDateFormatted(dateOriginal) {
      let date = new Date(dateOriginal.split("+", 1));
      return this.formatDatetimePtBr(date);
    },
    // Função que é chamada quando ocorre o scroll
    async handleScroll() {
      const scrollContainer = this.$refs.scrollContainer;

      // Verifica se o scroll está no topo
      const previousScrollHeight = scrollContainer.scrollHeight;

      // Adiciona novos itens no topo
      await this.addNewItems();

      // Garante que o scroll não "salte" após adicionar novos itens
      this.$nextTick(() => {
        scrollContainer.scrollTop =
          scrollContainer.scrollHeight - previousScrollHeight;
      });
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        await this.handleScroll();
      }
    },
  },
};
</script>
  
<style scoped>
#scroll-content {
  height: 400px;
  overflow: auto;
}
</style>